// import React, { useState, useEffect } from "react";
// import { Trash2, Plus, X, Upload, Image } from "lucide-react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import Loader from "../../components/common/Loader";

// const CampusGallery = () => {
//   const [galleries, setGalleries] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [galleryName, setGalleryName] = useState("");
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [isUploading, setIsUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;
//   const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_NAME;

//   const fetchGalleries = async () => {
//     try {
//       const config = {
//         method: "get",
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/campus-gallery/get-all`,
//         headers: {},
//       };
//       const startTime = Date.now();

//       const response = await axios.request(config);

//       if (response.data) {
//         setGalleries(response.data);
//       }
//       const elapsed = Date.now() - startTime;
//       const remaining = Math.max(1000 - elapsed, 0);

//       setTimeout(() => setIsLoading(false), remaining);
//     } catch (err) {
//       console.error("Error fetching galleries:", err);
//       setError(err.message);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchGalleries();
//   }, []);

//   const handleDelete = (galleryName, imageId) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         let config = {
//           method: "delete",
//           maxBodyLength: Infinity,
//           url: `${process.env.REACT_APP_API_URL}/campus-gallery/delete/${galleryName}/${imageId}`,
//           headers: {},
//         };

//         axios
//           .request(config)
//           .then((response) => {
//             console.log("Deleted:", response.data);
//             Swal.fire({
//               title: "Deleted!",
//               text: "The image has been deleted successfully.",
//               icon: "success",
//               timer: 1500,
//               showConfirmButton: false,
//             });
//             fetchGalleries();
//           })
//           .catch((error) => {
//             console.error("Delete error:", error);
//             Swal.fire({
//               title: "Error!",
//               text: "Something went wrong while deleting the image.",
//               icon: "error",
//             });
//           });
//       } else {
//         Swal.fire({
//           title: "Cancelled",
//           text: "Your image is safe 😊",
//           icon: "info",
//           timer: 1200,
//           showConfirmButton: false,
//         });
//       }
//     });
//   };

//   const handlegalaryDelete = (gallryId) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         let config = {
//           method: "delete",
//           maxBodyLength: Infinity,
//           url: `${process.env.REACT_APP_API_URL}/campus-gallery/delete-gallery/${gallryId}`,
//           headers: {},
//         };

//         axios
//           .request(config)
//           .then((response) => {
//             console.log("Deleted:", response.data);
//             Swal.fire({
//               title: "Deleted!",
//               text: "The Gallery has been deleted successfully.",
//               icon: "success",
//               timer: 1500,
//               showConfirmButton: false,
//             });
//             fetchGalleries();
//           })
//           .catch((error) => {
//             console.error("Delete error:", error);
//             Swal.fire({
//               title: "Error!",
//               text: "Something went wrong while deleting the Gallery.",
//               icon: "error",
//             });
//           });
//       } else {
//         Swal.fire({
//           title: "Cancelled",
//           text: "Your gallery is safe 😊",
//           icon: "info",
//           timer: 1200,
//           showConfirmButton: false,
//         });
//       }
//     });
//   };

//   const handleAddImage = () => {
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setGalleryName("");
//     setSelectedFiles([]);
//     setPreviewUrls([]);
//     setIsUploading(false);
//     setUploadProgress(0);
//   };

//   const handleFileSelect = (e) => {
//     const files = Array.from(e.target.files);

//     const validFiles = files.filter((file) => {
//       const isValid = file.type.startsWith("image/");
//       if (!isValid) {
//         Swal.fire({
//           title: "Invalid File",
//           text: `${file.name} is not an image file.`,
//           icon: "error",
//           timer: 2000,
//         });
//       }
//       return isValid;
//     });

//     setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);

//     validFiles.forEach((file) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewUrls((prev) => [...prev, reader.result]);
//       };
//       reader.readAsDataURL(file);
//     });
//   };

//   const handleRemoveFile = (index) => {
//     setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
//     setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
//   };

//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
//     formData.append("cloud_name", CLOUDINARY_CLOUD_NAME);

//     try {
//       const response = await axios.post(
//         `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
//         formData
//       );
//       return response.data.secure_url;
//     } catch (error) {
//       console.error("Error uploading to Cloudinary:", error);
//       throw error;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!galleryName.trim()) {
//       Swal.fire({
//         title: "Error!",
//         text: "Please enter a gallery name.",
//         icon: "error",
//       });
//       return;
//     }

//     if (selectedFiles.length === 0) {
//       Swal.fire({
//         title: "Error!",
//         text: "Please select at least one image to upload.",
//         icon: "error",
//       });
//       return;
//     }

//     setIsUploading(true);
//     setUploadProgress(0);

//     try {
//       const uploadedUrls = [];
//       const totalFiles = selectedFiles.length;

//       for (let i = 0; i < selectedFiles.length; i++) {
//         const url = await uploadToCloudinary(selectedFiles[i]);
//         uploadedUrls.push(url);
//         setUploadProgress(Math.round(((i + 1) / totalFiles) * 100));
//       }

//       let data = JSON.stringify({
//         name: galleryName,
//         images: uploadedUrls,
//       });

//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/campus-gallery/create`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: data,
//       };

//       await axios.request(config);

//       Swal.fire({
//         title: "Success!",
//         text: `Gallery "${galleryName}" with ${uploadedUrls.length} image(s) created successfully.`,
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       handleCloseModal();
//       fetchGalleries();
//     } catch (error) {
//       console.error("Error uploading images:", error);
//       Swal.fire({
//         title: "Error!",
//         text: "Something went wrong while uploading images.",
//         icon: "error",
//       });
//       setIsUploading(false);
//     }
//   };

//   const totalImages = galleries.reduce(
//     (acc, gallery) => acc + gallery.images.length,
//     0
//   );

//   return (
//     <div className="min-h-screen p-6 bg-gray-50">
//       <div className="w-full mx-auto">
//         <div className="mb-4 mt-6">
//           <div className="flex justify-between items-center mb-4">
//             <div>
//               <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
//                 Campus Gallery
//               </h1>
//             </div>
//             <button
//               className="bg-primaryBtnColor text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-all duration-300 shadow-md hover:shadow-lg"
//               onClick={handleAddImage}
//             >
//               <Plus size={20} />
//               Create Album
//             </button>
//           </div>
//         </div>

//         {isLoading ? (
//           <Loader />
//         ) : error ? (
//           <div className="col-span-full text-center py-16">
//             <div className="text-6xl mb-4">⚠️</div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-2">
//               Error Loading Galleries
//             </h3>
//             <p className="text-gray-600">{error}</p>
//           </div>
//         ) : (
//           <div className="space-y-8">
//             {galleries.map((gallery) => (
//               <div
//                 key={gallery._id}
//                 className="bg-white rounded-xl shadow-md p-6"
//               >
//                 <div className="flex justify-between items-center">
//                   <div className="mb-4">
//                     <h2 className="text-2xl font-bold text-gray-800">
//                       {gallery.name}
//                     </h2>
//                     <p className="text-sm text-gray-600">
//                       {gallery.images.length}{" "}
//                       {gallery.images.length === 1 ? "photo" : "photos"}
//                     </p>
//                   </div>
//                   <button
//                     onClick={() => handlegalaryDelete(gallery._id)}
//                     className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
//                   >
//                     <Trash2 size={16} />
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
//                   {gallery.images.map((image) => (
//                     <div
//                       key={image._id}
//                       className="bg-gray-100 rounded-lg shadow hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
//                     >
//                       <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
//                         <button
//                           onClick={() => handleDelete(gallery.name, image._id)}
//                           className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
//                         >
//                           <Trash2 size={16} />
//                         </button>
//                       </div>

//                       <div className="aspect-square overflow-hidden">
//                         <img
//                           src={image.url}
//                           alt={`${gallery.name} photo`}
//                           className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//                           onError={(e) => {
//                             e.target.src =
//                               "https://via.placeholder.com/400?text=Image+Not+Found";
//                           }}
//                         />
//                       </div>

//                       <div className="h-1 bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {!isLoading && galleries.length === 0 && (
//           <div className="text-center py-16">
//             <div className="text-6xl mb-4">📷</div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-2">
//               No Galleries Found
//             </h3>
//             <p className="text-gray-600 mb-6">
//               Start by creating your first photo album
//             </p>
//             <button
//               onClick={handleAddImage}
//               className="bg-primaryBtnColor text-white px-6 py-3 rounded-lg flex items-center gap-2 mx-auto transition-all duration-300"
//             >
//               <Plus size={20} />
//               Create Album
//             </button>
//           </div>
//         )}
//       </div>

//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
//             <div className="flex justify-between items-center p-6 border-b">
//               <h2 className="text-2xl font-bold text-gray-800">
//                 Create New Album
//               </h2>
//               <button
//                 onClick={handleCloseModal}
//                 className="text-gray-500 hover:text-gray-700 transition-colors"
//                 disabled={isUploading}
//               >
//                 <X size={24} />
//               </button>
//             </div>

//             <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-gray-800 mb-2">
//                   Album Name *
//                 </label>
//                 <input
//                   type="text"
//                   value={galleryName}
//                   onChange={(e) => setGalleryName(e.target.value)}
//                   placeholder="e.g., Sports Day 2026, Annual Function"
//                   className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   disabled={isUploading}
//                 />
//               </div>

//               <div className="mb-6">
//                 <label className="block text-sm font-semibold text-gray-800 mb-3">
//                   Select Images *
//                 </label>
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 transition-colors">
//                   <input
//                     type="file"
//                     multiple
//                     accept="image/*"
//                     onChange={handleFileSelect}
//                     className="hidden"
//                     id="file-upload"
//                     disabled={isUploading}
//                   />
//                   <label
//                     htmlFor="file-upload"
//                     className="cursor-pointer flex flex-col items-center"
//                   >
//                     <Image size={48} className="text-gray-400 mb-3" />
//                     <span className="text-blue-600 font-semibold mb-1">
//                       Click to upload
//                     </span>
//                     <span className="text-sm text-gray-500">
//                       or drag and drop images here
//                     </span>
//                     <span className="text-xs text-gray-400 mt-2">
//                       PNG, JPG, JPEG, GIF up to 10MB
//                     </span>
//                   </label>
//                 </div>
//               </div>

//               {previewUrls.length > 0 && (
//                 <div>
//                   <h3 className="text-lg font-semibold text-gray-800 mb-3">
//                     Selected Images ({selectedFiles.length})
//                   </h3>
//                   <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
//                     {previewUrls.map((url, index) => (
//                       <div key={index} className="relative group">
//                         <div className="aspect-square rounded-lg overflow-hidden border border-gray-200">
//                           <img
//                             src={url}
//                             alt={`Preview ${index + 1}`}
//                             className="w-full h-full object-cover"
//                           />
//                         </div>
//                         {!isUploading && (
//                           <button
//                             onClick={() => handleRemoveFile(index)}
//                             className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
//                           >
//                             <X size={16} />
//                           </button>
//                         )}
//                         <p className="text-xs text-gray-600 mt-1 truncate">
//                           {selectedFiles[index]?.name}
//                         </p>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {isUploading && (
//                 <div className="mt-6">
//                   <div className="flex justify-between items-center mb-2">
//                     <span className="text-sm font-semibold text-gray-800">
//                       Uploading...
//                     </span>
//                     <span className="text-sm text-gray-600">
//                       {uploadProgress}%
//                     </span>
//                   </div>
//                   <div className="w-full bg-gray-200 rounded-full h-2">
//                     <div
//                       className="bg-blue-600 h-2 rounded-full transition-all duration-300"
//                       style={{ width: `${uploadProgress}%` }}
//                     ></div>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
//               <button
//                 type="button"
//                 onClick={handleCloseModal}
//                 className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-all"
//                 disabled={isUploading}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSubmit}
//                 disabled={
//                   isUploading ||
//                   selectedFiles.length === 0 ||
//                   !galleryName.trim()
//                 }
//                 className="bg-primaryBtnColor text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {isUploading ? (
//                   <>
//                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
//                     Uploading...
//                   </>
//                 ) : (
//                   <>
//                     <Upload size={18} />
//                     Create Album{" "}
//                     {selectedFiles.length > 0 && `(${selectedFiles.length})`}
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CampusGallery;

import React, { useState, useEffect } from "react";
import { Trash2, Plus, X, Upload, Image, Video } from "lucide-react";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../components/common/Loader";

const CampusGallery = () => {
  const [galleries, setGalleries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [galleryName, setGalleryName] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;
  const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_NAME;

  const fetchGalleries = async () => {
    try {
      const config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/campus-gallery/get-all`,
        headers: {},
      };
      const startTime = Date.now();

      const response = await axios.request(config);

      if (response.data) {
        setGalleries(response.data);
      }
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(1000 - elapsed, 0);

      setTimeout(() => setIsLoading(false), remaining);
    } catch (err) {
      console.error("Error fetching galleries:", err);
      setError(err.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGalleries();
  }, []);

  const handleDelete = (galleryName, imageId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}/campus-gallery/delete/${galleryName}/${imageId}`,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            console.log("Deleted:", response.data);
            Swal.fire({
              title: "Deleted!",
              text: "The image has been deleted successfully.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
            fetchGalleries();
          })
          .catch((error) => {
            console.error("Delete error:", error);
            Swal.fire({
              title: "Error!",
              text: "Something went wrong while deleting the image.",
              icon: "error",
            });
          });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your image is safe 😊",
          icon: "info",
          timer: 1200,
          showConfirmButton: false,
        });
      }
    });
  };

  const handlegalaryDelete = (gallryId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: "delete",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL}/campus-gallery/delete-gallery/${gallryId}`,
          headers: {},
        };

        axios
          .request(config)
          .then((response) => {
            console.log("Deleted:", response.data);
            Swal.fire({
              title: "Deleted!",
              text: "The Gallery has been deleted successfully.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            });
            fetchGalleries();
          })
          .catch((error) => {
            console.error("Delete error:", error);
            Swal.fire({
              title: "Error!",
              text: "Something went wrong while deleting the Gallery.",
              icon: "error",
            });
          });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your gallery is safe 😊",
          icon: "info",
          timer: 1200,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleAddImage = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setGalleryName("");
    setSelectedFiles([]);
    setPreviewUrls([]);
    setIsUploading(false);
    setUploadProgress(0);
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);

    const validFiles = files.filter((file) => {
      const isImage = file.type.startsWith("image/");
      const isVideo = file.type.startsWith("video/");
      const isValid = isImage || isVideo;

      if (!isValid) {
        Swal.fire({
          title: "Invalid File",
          text: `${file.name} is not an image or video file.`,
          icon: "error",
          timer: 2000,
        });
        return false;
      }

      if (isVideo && file.size > 50 * 1024 * 1024) {
        Swal.fire({
          title: "File Too Large",
          text: `${file.name} exceeds 50MB limit for videos.`,
          icon: "error",
          timer: 2000,
        });
        return false;
      }

      return true;
    });

    const filesWithType = validFiles.map((file) => ({
      file,
      type: file.type.startsWith("image/") ? "image" : "video",
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    }));

    setSelectedFiles((prevFiles) => [...prevFiles, ...filesWithType]);

    filesWithType.forEach((fileObj) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrls((prev) => [...prev, reader.result]);
      };
      reader.readAsDataURL(fileObj.file);
    });
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    setPreviewUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadToCloudinary = async (file, fileType) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
    formData.append("cloud_name", CLOUDINARY_CLOUD_NAME);

    const resourceType = fileType === "video" ? "video" : "image";
    formData.append("resource_type", resourceType);

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Cloudinary upload failed: ${response.status}`);
      }

      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      console.error("Error uploading to Cloudinary:", error);
      throw error;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!galleryName.trim()) {
      Swal.fire({
        title: "Error!",
        text: "Please enter a gallery name.",
        icon: "error",
      });
      return;
    }

    if (selectedFiles.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please select at least one image or video to upload.",
        icon: "error",
      });
      return;
    }

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const uploadedUrls = [];
      const totalFiles = selectedFiles.length;

      for (let i = 0; i < selectedFiles.length; i++) {
        const url = await uploadToCloudinary(
          selectedFiles[i].file,
          selectedFiles[i].type
        );
        uploadedUrls.push(url);
        setUploadProgress(Math.round(((i + 1) / totalFiles) * 100));
      }

      let data = JSON.stringify({
        name: galleryName,
        images: uploadedUrls,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/campus-gallery/create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      await axios.request(config);

      Swal.fire({
        title: "Success!",
        text: `Gallery "${galleryName}" with ${uploadedUrls.length} item(s) created successfully.`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      handleCloseModal();
      fetchGalleries();
    } catch (error) {
      console.error("Error uploading media:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while uploading media.",
        icon: "error",
      });
      setIsUploading(false);
    }
  };

  const totalImages = galleries.reduce(
    (acc, gallery) => acc + gallery.images.length,
    0
  );

  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <div className="w-full mx-auto">
        <div className="mb-4 mt-6">
          <div className="flex justify-between items-center mb-4">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">
                Campus Gallery
              </h1>
            </div>
            <button
              className="bg-primaryBtnColor text-white px-6 py-3 rounded-lg flex items-center gap-2 transition-all duration-300 shadow-md hover:shadow-lg"
              onClick={handleAddImage}
            >
              <Plus size={20} />
              Create Album
            </button>
          </div>
        </div>

        {isLoading ? (
          <Loader />
        ) : error ? (
          <div className="col-span-full text-center py-16">
            <div className="text-6xl mb-4">⚠️</div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">
              Error Loading Galleries
            </h3>
            <p className="text-gray-600">{error}</p>
          </div>
        ) : (
          <div className="space-y-8">
            {galleries.map((gallery) => (
              <div
                key={gallery._id}
                className="bg-white rounded-xl shadow-md p-6"
              >
                <div className="flex justify-between items-center">
                  <div className="mb-4">
                    <h2 className="text-2xl font-bold text-gray-800">
                      {gallery.name}
                    </h2>
                    <p className="text-sm text-gray-600">
                      {gallery.images.length}{" "}
                      {gallery.images.length === 1 ? "item" : "items"}
                    </p>
                  </div>
                  <button
                    onClick={() => handlegalaryDelete(gallery._id)}
                    className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                  {gallery.images.map((image) => (
                    <div
                      key={image._id}
                      className="bg-gray-100 rounded-lg shadow hover:shadow-xl transition-all duration-300 group relative overflow-hidden"
                    >
                      <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                        <button
                          onClick={() => handleDelete(gallery.name, image._id)}
                          className="bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-all shadow-md"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>

                      <div className="aspect-square overflow-hidden relative">
                        {image.url.includes("/video/upload/") ||
                        image.url.match(/\.(mp4|webm|mov)$/i) ? (
                          <>
                            <video
                              src={image.url}
                              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                              controls={false}
                              muted
                            />
                            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20">
                              <Video size={32} className="text-white" />
                            </div>
                          </>
                        ) : (
                          <img
                            src={image.url}
                            alt={`${gallery.name} photo`}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/400?text=Media+Not+Found";
                            }}
                          />
                        )}
                      </div>

                      <div className="h-1 bg-gradient-to-r from-blue-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {!isLoading && galleries.length === 0 && (
          <div className="text-center py-16">
            <div className="text-6xl mb-4">📷</div>
            <h3 className="text-2xl font-bold text-gray-800 mb-2">
              No Galleries Found
            </h3>
            <p className="text-gray-600 mb-6">
              Start by creating your first photo album
            </p>
            <button
              onClick={handleAddImage}
              className="bg-primaryBtnColor text-white px-6 py-3 rounded-lg flex items-center gap-2 mx-auto transition-all duration-300"
            >
              <Plus size={20} />
              Create Album
            </button>
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-6 border-b">
              <h2 className="text-2xl font-bold text-gray-800">
                Create New Album
              </h2>
              <button
                onClick={handleCloseModal}
                className="text-gray-500 hover:text-gray-700 transition-colors"
                disabled={isUploading}
              >
                <X size={24} />
              </button>
            </div>

            <div className="p-6 overflow-y-auto max-h-[calc(90vh-180px)]">
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-800 mb-2">
                  Album Name *
                </label>
                <input
                  type="text"
                  value={galleryName}
                  onChange={(e) => setGalleryName(e.target.value)}
                  placeholder="e.g., Sports Day 2026, Annual Function"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={isUploading}
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-800 mb-3">
                  Select Images & Videos *
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 transition-colors">
                  <input
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    onChange={handleFileSelect}
                    className="hidden"
                    id="file-upload"
                    disabled={isUploading}
                  />
                  <label
                    htmlFor="file-upload"
                    className="cursor-pointer flex flex-col items-center"
                  >
                    <Image size={48} className="text-gray-400 mb-3" />
                    <span className="text-blue-600 font-semibold mb-1">
                      Click to upload
                    </span>
                    <span className="text-sm text-gray-500">
                      or drag and drop images/videos here
                    </span>
                    <span className="text-xs text-gray-400 mt-2">
                      Images: PNG, JPG, JPEG, GIF | Videos: MP4, WebM (Max 50MB)
                    </span>
                  </label>
                </div>
              </div>

              {previewUrls.length > 0 && (
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-3">
                    Selected Media ({selectedFiles.length})
                  </h3>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                    {previewUrls.map((url, index) => (
                      <div key={index} className="relative group">
                        <div className="aspect-square rounded-lg overflow-hidden border border-gray-200 bg-gray-100 relative">
                          {selectedFiles[index].type === "video" ? (
                            <>
                              <video
                                src={url}
                                className="w-full h-full object-cover"
                                controls={false}
                                muted
                              />
                              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20">
                                <Video size={24} className="text-white" />
                              </div>
                            </>
                          ) : (
                            <img
                              src={url}
                              alt={`Preview ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          )}
                        </div>
                        {!isUploading && (
                          <button
                            onClick={() => handleRemoveFile(index)}
                            className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
                          >
                            <X size={16} />
                          </button>
                        )}
                        <p className="text-xs text-gray-600 mt-1 truncate">
                          {selectedFiles[index]?.file?.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {isUploading && (
                <div className="mt-6">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-semibold text-gray-800">
                      Uploading...
                    </span>
                    <span className="text-sm text-gray-600">
                      {uploadProgress}%
                    </span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                      style={{ width: `${uploadProgress}%` }}
                    ></div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
              <button
                type="button"
                onClick={handleCloseModal}
                className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-all"
                disabled={isUploading}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                disabled={
                  isUploading ||
                  selectedFiles.length === 0 ||
                  !galleryName.trim()
                }
                className="bg-primaryBtnColor text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isUploading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Uploading...
                  </>
                ) : (
                  <>
                    <Upload size={18} />
                    Create Album{" "}
                    {selectedFiles.length > 0 && `(${selectedFiles.length})`}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampusGallery;
